export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '90bba4fa-b8cc-47c6-bf55-c3fa5e58d7a8';
export const MODAL_CLOSE_SEC = 2.5;
